export enum SearchBarEvents {
  ClearedText = 'Search Bar Cleared Text',
  Focused = 'Search Bar Focused',
  GoClicked = 'Go Clicked',
  NoResults = 'No Results',
  PressedEnter = 'Pressed Enter',
  RemovedRecentSearch = 'Removed Recent Search',
  SuggestionClicked = 'Suggestion Clicked'
}

export const SUBMITTED_INPUT_NO_SELECTION = {
  href: '/cars',
  searchType: null,
  text: null
};

export const SectionTitles = {
  RECENT_SEARCHES_TITLE: 'Your Recent Searches',
  KEYWORD_SUGGESTIONS_TITLE: 'Suggestions',
  SAVED_SEARCHES_TITLE: 'Saved Searches',
  LEGACY_RECENT_SEARCHES_TITLE: 'Recent Searches'
};
